/* FAQ accordion — Nimble. One open at a time, keyboard accessible. */
(function () {
  function close(item) {
    var body = item.querySelector('.faq-accordion__item-description');
    var title = item.querySelector('.faq-accordion__item-title');
    body.style.height = body.scrollHeight + 'px';
    requestAnimationFrame(function () {
      body.style.height = '0px';
      body.style.paddingBottom = '0px';
    });
    item.classList.remove('is-open');
    if (title) title.setAttribute('aria-expanded', 'false');
  }
  function open(item) {
    var body = item.querySelector('.faq-accordion__item-description');
    var title = item.querySelector('.faq-accordion__item-title');
    item.classList.add('is-open');
    if (title) title.setAttribute('aria-expanded', 'true');
    body.style.paddingBottom = '22px';
    body.style.height = body.scrollHeight + 22 + 'px';
    body.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'height') return;
      body.removeEventListener('transitionend', done);
      if (item.classList.contains('is-open')) body.style.height = 'auto';
    });
  }
  function init(scope) {
    (scope || document).querySelectorAll('.faq-accordion').forEach(function (root) {
      if (root.dataset.nmFaq) return;
      root.dataset.nmFaq = '1';
      var items = root.querySelectorAll('.faq-accordion__item');
      items.forEach(function (item) {
        var title = item.querySelector('.faq-accordion__item-title');
        if (!title) return;
        function toggle() {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (other) { if (other !== item && other.classList.contains('is-open')) close(other); });
          isOpen ? close(item) : open(item);
        }
        title.addEventListener('click', toggle);
        title.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
